<template>
  <v-row
    v-if="enableAttendanceV2"
    :class="['mb-3', { 'position-sticky': sticky }]"
    :style="sticky ? 'top: -16px; z-index: 10; background: white;' : ''"
    data-testId="attendance-log-editor-filter"
    dense
  >
    <v-col cols="auto">
      <FilterMenu
        :active="selectedMonths.length > 0"
        classes="d-md-inline-flex"
        test-id="month-filter-button"
        title="Months"
        paddingless
      >
        <template #card>
          <v-autocomplete
            v-model="selectedMonths"
            @update:model-value="emit('update-filter', { key: 'month_year', value: $event })"
            :aria-label="$bct('Filter by month')"
            :item-title="(item) => `${$bct(assets.months[item.value.month])} ${item.value.year}`"
            :item-value="(item) => item.value"
            :items="monthOptions"
            :menu="true"
            :placeholder="$bct('Filter by month')"
            density="compact"
            prepend-inner-icon="search"
            variant="filled"
            autofocus
            chips
            clearable
            multiple
          />
        </template>
      </FilterMenu>
    </v-col>

    <v-col cols="auto">
      <FilterMenu
        :active="currentSubmittedFilter.length > 0"
        classes="d-md-inline-flex"
        test-id="status-filter-button"
        title="Status"
        paddingless
      >
        <template #card>
          <v-autocomplete
            @update:model-value="emit('update-filter', { key: 'submitted', value: $event })"
            :aria-label="$bct('Filter by status')"
            :item-title="(item) => $bct(item)"
            :items="statusOptions"
            :menu="true"
            :model-value="currentSubmittedFilter"
            :placeholder="$bct('Filter by status')"
            density="compact"
            prepend-inner-icon="search"
            variant="filled"
            autofocus
            chips
            clearable
            multiple
          />
        </template>
      </FilterMenu>
    </v-col>
  </v-row>
</template>

<script setup>
import FilterMenu from '@/shared/components/form/FilterMenu.vue';
import useAssets from '@/shared/composables/useAssets';

const $bct = inject('translator');

const { assets } = useAssets();

const emit = defineEmits(['update-filter']);

const props = defineProps({
  currentSubmittedFilter: {
    type: Array,
    default: () => [],
  },
  enableAttendanceV2: {
    type: Boolean,
    default: false,
  },
  monthFilterSelections: {
    type: Array,
    default: () => [],
  },
  monthOptions: {
    type: Array,
    required: true,
  },
  sticky: {
    type: Boolean,
    default: false,
  },
});

const selectedMonths = ref(props.monthFilterSelections);

const isFilteredToSingleMonth = computed(() => selectedMonths.value.length === 1);

const statusOptions = ['Submitted', 'Unsubmitted'];

watch(
  () => props.monthFilterSelections,
  (newValue) => (selectedMonths.value = newValue),
);

defineExpose({
  isFilteredToSingleMonth,
});
</script>
